import { defineStore } from 'pinia'
import UserService from '~/services/MSAPI/user'

export interface ICustomizationState {
  isWhiteLabel: boolean
  logoUrl: string
  loginScreenImageUrl: string
  iconUrl?: string
  brandName?: string
  isStarted: boolean
}

export const useWhitelabelStore = defineStore('whitelabel', () => {
  const defaultLogoURL = '/img/logo-color.svg'
  // const defaultLogoURL = '/img/logo-color.svg'
  const defaultLoginScreenImageURL = '/img/bg-auth.png'
  const defaultIconURL = 'arpoone.svg'
  const defaultBrandName = 'Arpoone'

  const whitelabelData = ref<ICustomizationState>({
    isWhiteLabel: false,
    logoUrl: '',
    loginScreenImageUrl: '',
    iconUrl: '',
    brandName: '',
    isStarted: false,
  })

  async function initStore(organizationId?: string) {
    const userService = new UserService()
    whitelabelData.value.isStarted = true

    if (organizationId) {
      const response =
        await userService.organizationCustomization.getOrganizationCustomizationById(
          organizationId,
        )
      if (response?.data) {
        whitelabelData.value.isWhiteLabel = true
        whitelabelData.value.logoUrl = response.data?.logoUrl || defaultLogoURL
        whitelabelData.value.loginScreenImageUrl =
          response.data?.loginScreenImageUrl || defaultLoginScreenImageURL
        configurePageTitle(response.data?.logoUrl, response.data?.brandName)
      } else {
        whitelabelData.value.isWhiteLabel = false
        whitelabelData.value.logoUrl = defaultLogoURL
        whitelabelData.value.loginScreenImageUrl = defaultLoginScreenImageURL
        configurePageTitle()
      }
    } else {
      const response =
        await userService.organizationCustomization.getOrganizationCustomization()
      if (response?.data) {
        whitelabelData.value.isWhiteLabel = true
        whitelabelData.value.logoUrl = response.data?.logoUrl || defaultLogoURL
        whitelabelData.value.loginScreenImageUrl =
          response.data?.loginScreenImageUrl || defaultLoginScreenImageURL
        configurePageTitle(response.data?.logoUrl, response.data?.brandName)
      } else {
        whitelabelData.value.isWhiteLabel = false
        whitelabelData.value.logoUrl = defaultLogoURL
        whitelabelData.value.loginScreenImageUrl = defaultLoginScreenImageURL
        configurePageTitle()
      }
    }
  }

  const configurePageTitle = (logoutUrl?: string, brandName?: string) => {
    const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement

    if (link) {
      link.href = logoutUrl || defaultIconURL
    } else {
      const newLink = document.createElement('link')
      newLink.rel = 'icon'
      newLink.href = logoutUrl || defaultIconURL
      document.head.appendChild(newLink)
    }

    document.title = brandName || defaultBrandName
  }

  const refreshWhitelabel = () => {
    whitelabelData.value.isStarted = false
  }

  return { whitelabelData, initStore, refreshWhitelabel }
})
